import React from "react";
import { useNavigate } from "react-router-dom";
import { MessageProgramming, Translate, ArrowRight2 } from "iconsax-react";

import MobileLayout from "../../components/MobileLayout";
import { Grid, Card } from "./styles";

const AIAssistant: React.FC = () => {
  const navigate = useNavigate();

  return (
    <MobileLayout headerTitle="Assistente IA" headerType="private">
      <div style={{ padding: "0 16px", marginTop: "16px" }}>
        <Grid>
          <Card onClick={() => navigate("/ai-assistant/tutor")}>
            <div className="icon-wrapper tutor">
              <MessageProgramming size="32" variant="Bold" />
            </div>
            <div className="content">
              <h3>Tutor IA</h3>
              <p>
                Tire dúvidas sobre Libras, gramática e cultura surda em tempo
                real.
              </p>
            </div>
            <ArrowRight2 className="arrow" size="24" />
          </Card>

          <Card onClick={() => navigate("/ai-assistant/translator")}>
            <div className="icon-wrapper translator">
              <Translate size="32" variant="Bold" />
            </div>
            <div className="content">
              <h3>Tradutor de Glosa</h3>
              <p>
                Converta frases do Português para a estrutura de Glosa da
                Libras.
              </p>
            </div>
            <ArrowRight2 className="arrow" size="24" />
          </Card>
        </Grid>
      </div>
    </MobileLayout>
  );
};

export default AIAssistant;
